var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsGrid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dots-grid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5C12.4142 7.5 12.75 7.16421 12.75 6.75C12.75 6.33579 12.4142 6 12 6C11.5858 6 11.25 6.33579 11.25 6.75C11.25 7.16421 11.5858 7.5 12 7.5Z",
    fill: "#9AA4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75C12.4142 12.75 12.75 12.4142 12.75 12C12.75 11.5858 12.4142 11.25 12 11.25C11.5858 11.25 11.25 11.5858 11.25 12C11.25 12.4142 11.5858 12.75 12 12.75Z",
    fill: "#9AA4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18C12.4142 18 12.75 17.6642 12.75 17.25C12.75 16.8358 12.4142 16.5 12 16.5C11.5858 16.5 11.25 16.8358 11.25 17.25C11.25 17.6642 11.5858 18 12 18Z",
    fill: "#9AA4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 7.5C17.6642 7.5 18 7.16421 18 6.75C18 6.33579 17.6642 6 17.25 6C16.8358 6 16.5 6.33579 16.5 6.75C16.5 7.16421 16.8358 7.5 17.25 7.5Z",
    fill: "#9AA4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12.75C17.6642 12.75 18 12.4142 18 12C18 11.5858 17.6642 11.25 17.25 11.25C16.8358 11.25 16.5 11.5858 16.5 12C16.5 12.4142 16.8358 12.75 17.25 12.75Z",
    fill: "#9AA4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 18C17.6642 18 18 17.6642 18 17.25C18 16.8358 17.6642 16.5 17.25 16.5C16.8358 16.5 16.5 16.8358 16.5 17.25C16.5 17.6642 16.8358 18 17.25 18Z",
    fill: "#9AA4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.5C7.16421 7.5 7.5 7.16421 7.5 6.75C7.5 6.33579 7.16421 6 6.75 6C6.33579 6 6 6.33579 6 6.75C6 7.16421 6.33579 7.5 6.75 7.5Z",
    fill: "#9AA4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12.75C7.16421 12.75 7.5 12.4142 7.5 12C7.5 11.5858 7.16421 11.25 6.75 11.25C6.33579 11.25 6 11.5858 6 12C6 12.4142 6.33579 12.75 6.75 12.75Z",
    fill: "#9AA4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 18C7.16421 18 7.5 17.6642 7.5 17.25C7.5 16.8358 7.16421 16.5 6.75 16.5C6.33579 16.5 6 16.8358 6 17.25C6 17.6642 6.33579 18 6.75 18Z",
    fill: "#9AA4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5C12.4142 7.5 12.75 7.16421 12.75 6.75C12.75 6.33579 12.4142 6 12 6C11.5858 6 11.25 6.33579 11.25 6.75C11.25 7.16421 11.5858 7.5 12 7.5Z",
    stroke: "#9AA4B2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75C12.4142 12.75 12.75 12.4142 12.75 12C12.75 11.5858 12.4142 11.25 12 11.25C11.5858 11.25 11.25 11.5858 11.25 12C11.25 12.4142 11.5858 12.75 12 12.75Z",
    stroke: "#9AA4B2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18C12.4142 18 12.75 17.6642 12.75 17.25C12.75 16.8358 12.4142 16.5 12 16.5C11.5858 16.5 11.25 16.8358 11.25 17.25C11.25 17.6642 11.5858 18 12 18Z",
    stroke: "#9AA4B2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 7.5C17.6642 7.5 18 7.16421 18 6.75C18 6.33579 17.6642 6 17.25 6C16.8358 6 16.5 6.33579 16.5 6.75C16.5 7.16421 16.8358 7.5 17.25 7.5Z",
    stroke: "#9AA4B2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12.75C17.6642 12.75 18 12.4142 18 12C18 11.5858 17.6642 11.25 17.25 11.25C16.8358 11.25 16.5 11.5858 16.5 12C16.5 12.4142 16.8358 12.75 17.25 12.75Z",
    stroke: "#9AA4B2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 18C17.6642 18 18 17.6642 18 17.25C18 16.8358 17.6642 16.5 17.25 16.5C16.8358 16.5 16.5 16.8358 16.5 17.25C16.5 17.6642 16.8358 18 17.25 18Z",
    stroke: "#9AA4B2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.5C7.16421 7.5 7.5 7.16421 7.5 6.75C7.5 6.33579 7.16421 6 6.75 6C6.33579 6 6 6.33579 6 6.75C6 7.16421 6.33579 7.5 6.75 7.5Z",
    stroke: "#9AA4B2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12.75C7.16421 12.75 7.5 12.4142 7.5 12C7.5 11.5858 7.16421 11.25 6.75 11.25C6.33579 11.25 6 11.5858 6 12C6 12.4142 6.33579 12.75 6.75 12.75Z",
    stroke: "#9AA4B2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 18C7.16421 18 7.5 17.6642 7.5 17.25C7.5 16.8358 7.16421 16.5 6.75 16.5C6.33579 16.5 6 16.8358 6 17.25C6 17.6642 6.33579 18 6.75 18Z",
    stroke: "#9AA4B2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsGrid);
export default __webpack_public_path__ + "static/media/dots-grid.47e452dc992cedfc76e076a687760901.svg";
export { ForwardRef as ReactComponent };